import { ACTIVITY_DATE_FIELDS } from "@repo/shared/types";

/**
 * Client timestamps a client card can show: the six filterable activity
 * columns plus `createdAt`. Settings, the client card and the filter bar each
 * keep their own copy of the labels (`ACTIVITY_DATE_LABELS`) in their sidecar.
 */
export const ACTIVITY_DATE_DISPLAY_FIELDS = [...ACTIVITY_DATE_FIELDS, "createdAt"] as const;
export type ActivityDateFieldValue = (typeof ACTIVITY_DATE_DISPLAY_FIELDS)[number];
